/* eslint-disable react/no-danger */
import React, { useEffect, useState } from "react";
import classnames from "classnames";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";
import { getSolutionContactDetails } from "../../utils/data/getContactDetails";

// Components
import ContactMethods from "../contact-details-box/contact-methods/ContactMethods";

// Styles
import styles from "./ContactUsRepairUpdateElectricalItem.module.scss";

function ContactUsRepairUpdateElectricalItem({ solution: { id, title, fields, hierarchyPosition }, className }) {
  const locationOnPage = hierarchyPosition.join(" | ");
  const [contactDetails, setContactDetails] = useState(null);

  useEffect(() => {
    getSolutionContactDetails(locationOnPage)
      .then(res => setContactDetails(res))
      .catch(() => setContactDetails(null));
  }, []);

  return (
    <article className={classnames(styles.repairUpdateElectricalItem, className)} data-solution-id={id}>
      <h2 className={styles.repairUpdateElectricalItem__top}>Did you know...</h2>

      <div className={styles.repairUpdateElectricalItem__inner} data-test="solution-inner">
        {title && (
          <h2 data-test="solution-name" className={styles.repairUpdateElectricalItem__title}>
            {title}
          </h2>
        )}

        <div className={styles["repairUpdateElectricalItem__contact-details"]}>
          {!contactDetails && <LoadingSpinner />}
          {contactDetails && (
            <ContactMethods
              fields={fields.filter(({ name }) => ["phone", "chat"].includes(name))}
              solutionId={id}
              location={locationOnPage}
              contactDetails={contactDetails}
            />
          )}
        </div>
      </div>
    </article>
  );
}

export default ContactUsRepairUpdateElectricalItem;
